import axios from 'axios';
import ShiftDigitalContainer from '../../../Events/ShiftDigital/ShiftDigitalContainer';
import ShiftDigitalService from '../../../Events/ShiftDigital/ShiftDigitalService';
import {
  fireTypedSearchEvents,
  onCommonLinkLogs,
} from '../../../Events/TagManagerServices/TaggingEventForPages';
import vClickOutside from 'click-outside-vue3';
import { mapWritableState } from 'pinia';
import { useSearchMenuStore } from '../../../store/Shared/SearchMenuStore/SearchMenuStore';
export default {
  data() {
    return {
      baseUrl: window.baseUrl,
      searchkey: '',
      debounceTimer: null,
      vehiclesdata: [],
      boxstyle: {},
      actualVehiclesData: [],
      controller: null,
      hideVINandStock: window.hideVINandStock,
      isSearchBarNoResultsText: window.searchBarNoResultsText,
      focus: null,
      isGenesis: window.make?.toLowerCase() === 'genesis',
    };
  },
  directives: {
    ClickOutside: vClickOutside.directive,
  },
  props: {
    position: {
      type: String,
      required: false,
      default: 'bottom',
    },
    searchtype: {
      type: String,
      required: false,
      default: '',
    },
    isluxury: {
      required: false,
      default: false,
    },
    placeholderfromtopfilters: {
      required: false,
      default: false,
    },
    hidePlaceholderText: {
      required: false,
      default: false,
    },
    placeHolderTextValue: {
      required: false,
      default: 'Search by Year, Make and Model',
    },
  },
  computed: {
    setPlaceholderText() {
      if (this.hidePlaceholderText) return '';
      const defaultPlaceholders = {
        mobile: 'Search',
        topFilters: 'Search by model or keyword',
        withOutVinandStock: 'Search by Year, Make, Model or Trim',
        default: 'Search by Make, Model, Stock Number or VIN',
      };
      if (this.placeHolderTextValue) {
        return this.placeHolderTextValue;
      } else if (this.placeholderfromtopfilters) {
        return window.ismobile ? defaultPlaceholders.mobile : defaultPlaceholders.topFilters;
      } else if (this.hideVINandStock) {
        return defaultPlaceholders.withOutVinandStock;
      } else {
        return defaultPlaceholders.default;
      }
    },
    ...mapWritableState(useSearchMenuStore, ['showVehicleSearch']),
  },
  methods: {
    searchVehicles(event) {
      if (this.searchkey.length < 2) return false;
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.cancelSearch();

        this.controller = new AbortController();
        let url = `${window.ApiBaseUrl}/Inventory/Search?accountId=${window.accountId}&searchkeyword=${this.searchkey}`;
        if (window.inventoryType) {
          url = `${url}
						&searchType=${window.inventoryType}`;
        }
        this.focus = 0;
        axios
          .get(url, {
            signal: this.controller.signal,
          })
          .then((response) => {
            fireTypedSearchEvents(this.searchkey);
            this.actualVehiclesData = response.data;
            this.formatVehicles(response.data);
            this.searchEvents();
          });
      }, 1000);
    },
    searchEvents() {
      let shiftDigital = ShiftDigitalContainer.getShiftDigitalObject();
      if (shiftDigital && !this.isGenesis) {
        ShiftDigitalService.shiftDigitalTypedSeachEvent(shiftDigital, this.searchkey);
      }
      if (shiftDigital && typeof shiftDigital.siteSearch === 'function') {
        shiftDigital.siteSearch({ response: response.data, searchKey: this.searchKey });
      }
    },
    cancelSearch() {
      if (this.controller) {
        this.controller.abort('Start new search, stop active search');
      }
    },
    removeSearch() {
      this.vehiclesdata = [];
    },
    formatVehicles(data) {
      
      if(data.length) {
        this.vehiclesdata = data;
      }
      else {
        this.vehiclesdata = [{
          vehcileName:'No Results Found',
          link:'/inventory/new/noresult',
        }]
      }
    },
    navigateToFirstVehicle() {
      if (this.actualVehiclesData) {
        let index = this.focus && this.actualVehiclesData[this.focus] ? this.focus : 0;
        const focusedItem = this.$refs.vehicleItems?.find((item) =>
          item.classList.contains('focus')
        );
        focusedItem?.querySelector('a')?.click();
        this.searchItemClick(index);
      }
    },
    searchItemClick(index) {
      try {
        let url = '';
        let label = '';
        if (this.actualVehiclesData?.length && this.actualVehiclesData[index]) {
          label = this.actualVehiclesData[index].vehcileName;
          url = this.actualVehiclesData[index].link;
        } else {
          label = 'No Results Found';
        }
        onCommonLinkLogs({ label, url });
      } catch (error) {
        console.log(error);
      }
      this.isGenesis && sessionStorage.setItem('sdaSearchKeyForGenesis', this.searchkey); // for SD analytics input search
    },
    selectSearch(event) {
      switch (event.keyCode) {
        case 38:
          if (this.focus === null) {
            this.focus = 0;
            this.fixScrolling();
          } else if (this.focus > 0) {
            this.focus--;
            this.fixScrolling();
          } else {
            // No action needed for other cases.
          }
          break;
        case 40:
          if (this.focus === null) {
            this.focus = 0;
            this.fixScrolling();
          } else if (this.focus < this.vehiclesdata.length - 1) {
            this.focus++;
            this.fixScrolling();
          } else {
            // No action needed for other cases.
          }
          break;
        case 9:
          //tab pressed
          event.preventDefault();
          if (event.shiftKey) {
            if (this.focus === null) {
              this.focus = 0;
              this.fixScrolling();
            } else if (this.focus <= this.vehiclesdata.length - 1) {
              if (this.focus === 0) {
                this.focus = this.vehiclesdata.length - 1;
              } else {
                this.focus--;
              }
              this.fixScrolling();
            } else {
              // No action needed for other cases.
            }
          } else if (this.focus === null) {
            this.focus = 0;
            this.fixScrolling();
          } else if (this.focus < this.vehiclesdata.length - 1) {
            this.focus++;
            this.fixScrolling();
          } else {
            // No action needed for other cases.
          }

          break;
      }
    },
    fixScrolling() {
      setTimeout(() => {
        try {
          document
            .querySelector('.vehicles-dropdown li.focus')
            .scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        } catch (error) {
          console.log(error);
        }
      }, 100);
    },
  },
};
